import { useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';

export function useTargetDigitalOptometry() {
  const targetDigitalOptometryCookie = getCookieByName(
    'targetDigitalOptometry',
    false
  );
  const targetDigitalOptometryConfig = useSelector(
    (state: any) => state.config.layoutSettings?.targetDigitalOptometry
  );
  const targetDigitalOptometry = useSelector(
    (state: any) =>
      state.workflow.flowDefiningAttributes?.targetDigitalOptometry
  );

  if (
    targetDigitalOptometryCookie !== null &&
    targetDigitalOptometryCookie !== undefined
  ) {
    return targetDigitalOptometryCookie as string;
  }
  if (
    targetDigitalOptometryConfig !== null &&
    targetDigitalOptometryConfig !== undefined
  ) {
    return targetDigitalOptometryConfig as string[];
  }
  if (targetDigitalOptometry !== null && targetDigitalOptometry !== undefined) {
    return targetDigitalOptometry as string[];
  }
  return [];
}
